import { Component, OnInit } from '@angular/core';
import { faTwitter , faInstagram, faGithub, faLinkedin} from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  
  }

  tw = faTwitter;
  git = faGithub;
  in = faInstagram;
  ln = faLinkedin;

}
